import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

import HeaderMain from '../components/header-main'
import Card from '../components/card'
import FooterMain from '../components/footer-main'
import './founders.css'

const Founders = (props) => {
  return (
    <div className="founders-container">
      <Helmet>
        <title>Основатели Arcobo — Жабрев Леонид и Мушников Игорь</title>
        <meta
          name="description"
          content="Основатели компании Arcobo: Жабрев Леонид (CEO) и Мушников Игорь (CTO) — роботизация производства, сварочные роботы и WAAM 3D-печать металлом."
        />
        <meta
          property="og:title"
          content="Основатели Arcobo — Жабрев Леонид и Мушников Игорь"
        />
        <meta
          property="og:description"
          content="Основатели компании Arcobo: Жабрев Леонид (CEO) и Мушников Игорь (CTO)."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Основатели Arcobo — Жабрев Леонид и Мушников Игорь"
        />
        <meta
          name="twitter:description"
          content="Основатели компании Arcobo: Жабрев Леонид (CEO) и Мушников Игорь (CTO)."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link rel="canonical" href="https://arcobo.tech/founders" />
        <meta
          property="og:url"
          content="https://arcobo.tech/founders"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"Founders","item":"https://arcobo.tech/founders"}]}',
          }}
        />
      </Helmet>
      <HeaderMain></HeaderMain>
      <section className="founders-hero">
        <h1 className="founders-title H1_large">Основатели</h1>
        <p className="founders-subtitle H1_small">
          Команда, которая создаёт и развивает Arcobo
        </p>
      </section>
      <section className="founders-grid">
        <Link to="/leonid-zhabrev" className="founders-card-link">
          <Card
            imageSrc="/Founders/leonid-zhabrev-card.webp"
            imageAlt="Жабрев Леонид — CEO Arcobo"
            heading1={
              <Fragment>
                <span>Жабрев Леонид</span>
              </Fragment>
            }
            text={
              <Fragment>
                <span>CEO</span>
              </Fragment>
            }
          ></Card>
        </Link>
        <Link to="/igor-mushnikov" className="founders-card-link">
          <Card
            imageSrc="/Founders/igor-mushnikov-card.webp"
            imageAlt="Мушников Игорь — CTO Arcobo"
            heading1={
              <Fragment>
                <span>Мушников Игорь</span>
              </Fragment>
            }
            text={
              <Fragment>
                <span>CTO</span>
              </Fragment>
            }
          ></Card>
        </Link>
      </section>
      <FooterMain></FooterMain>
    </div>
  )
}

export default Founders
